import { useCallback } from 'react';

const SUPERADMIN = 'superadmin';

export function usePermission(usuario) {
  const can = useCallback((modulo, accion) => {
    if (!usuario?.permisos) return false;
    if (usuario.rol_nombre === SUPERADMIN) return true;
    return !!usuario.permisos[modulo]?.[accion];
  }, [usuario]);

  const canView = useCallback((modulo) => can(modulo, 'ver'), [can]);

  return { can, canView };
}
